import {Component, ConfigOptions} from 'panel';
import QRious from 'qrious';

import {apiClient} from 'common/util/api-client';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {ToastType} from 'common/components/toast/types';
import {TwoFactorOption} from 'common/widgets/two-factor-selection-menu';
import {addToast} from 'common/components/toast-area/toast-manager';

import {template} from './template';
import './index.styl';

const QR_CODE_CANVAS_CLASS = `qr`;
const MISSING_CANVAS_ERROR = `Could not load Google Authenticator QR code. Please reload the page.`;

/**
 * This interface represents the shape of the JSON responses that the /security/totp/
 * endpoint returns.
 */

export interface QrCodeResponse {
  qrPath: string;
  secret: string;
}

export interface QrCodeState {
  showSecretModal: boolean;
  secret: string;
}

function showError(errorText) {
  addToast({
    isStatic: true,
    message: errorText,
    type: ToastType.ERROR,
  });
}

export class QrCode extends Component<QrCodeState> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
    };
  }

  get config(): ConfigOptions<QrCodeState> {
    return {
      template,
      defaultState: {showSecretModal: false, secret: ``},
      helpers: {
        getQrCodeCanvasClassName: (): string => {
          return QR_CODE_CANVAS_CLASS;
        },
        showSecretCodeModal: (): void => {
          this.update({showSecretModal: true});
        },
        closeSecretCodeModal: (): void => {
          this.update({showSecretModal: false});
        },
      },
    };
  }

  async connectedCallback(): Promise<void> {
    super.connectedCallback();
    const {qrPath, secret} = await this.getQrCodePath();
    this.showQrCodeFor(qrPath);
    this.update({secret});
  }

  async getQrCodePath(): Promise<QrCodeResponse> {
    const {qr_path: qrPath, secret} = await apiClient.post(`/security/twofactor/setup/totp/`, {
      twofactor_selection: TwoFactorOption.TOTP,
    });
    return {qrPath, secret};
  }

  showQrCodeFor(path: string): void {
    const qrCodeCanvas = document.getElementsByClassName(QR_CODE_CANVAS_CLASS)[0];
    if (qrCodeCanvas) {
      new QRious({
        element: qrCodeCanvas,
        value: path,
      });
    } else {
      showError(MISSING_CANVAS_ERROR);
    }
  }
}

export const QrCodeEl = defineAndMakeJsxFactory(`mp-totp-qr-code`, QrCode);
